import { requestV3 } from '@/libs/ajax';
import qs from 'qs';
/**
 * 获取均值出价
 * @param {*} params 
 * @returns 
 */
export function getConversionPriceApi(params) {
    return requestV3({
        url: '/batch/honor/conversion/price',
        method: 'get',
        params
    })
}
/**
 * 获取最低出价
 * @param {*} params 
 * @returns 
 */
export function getFloorPriceApi(data) {
    return requestV3({
        url: '/batch/placement/floor/price',
        method: 'post',
        data
    })
}
export function postBatchHonorPreviewApi(data) {
    return requestV3({
        url: '/honor/batch/preview',
        method: 'post',
        data
    })
}
/**
 * 批量创建生成预览 
 * @param {*} data 
 * @returns 
 */
export function postBatchHonorSavaApi(data) {
    return requestV3({
        url: '/honor/batch/save',
        method: 'post',
        data: qs.stringify(data)
    })
}
// 设置素材名称
export function postMaterialNameToAdNameApi(data) {
    return requestV3({
        url: '/honor/batch/putMaterialNameToAdName',
        method: 'post',
        data: qs.stringify(data)
    })
}
/**
 * 修改广告信息
 * @param {*} data 
 * @returns 
 */
export function postModifyAdInfoApi(data) {
    return requestV3({
        url: '/honor/batch/modifyAdInfo',
        method: 'post',
        data: qs.stringify(data)
    })
}
